import { Shimmer } from '@wartek-id/shimmer'

import Accordion from './Accordion'
import DataBlockLoading from './DataBlockLoading'
import DataBlock from './DataBlock'
import DataInfo from './DataInfo'
import { formatDate } from 'utils/datetime'
import {
  getIsValidData,
  getIsValidCertificate,
} from './helpers/data-validation'
import { LABEL_NOT_AVAILABLE } from '../constants'

import type { IBCKSKepalaSekolahEligibility } from 'types/bcks'
import type { FC } from 'react'

interface BlockCertificationProps {
  isLoading?: boolean
  data: IBCKSKepalaSekolahEligibility['certificate']
}

const BlockCertification: FC<BlockCertificationProps> = ({
  isLoading = false,
  data,
}) => {
  const isValidNoSertifikatPendidik = getIsValidData(
    data?.nomorSertifikatPendidik
  )
  const isValidNoSertifikatGp = getIsValidData(data?.nomorSertifikatGp)
  const isValidNoSertifikatDiklatCKS = getIsValidData(data?.nomorSertifikatNrks)

  return (
    <Accordion
      isLoading={isLoading}
      title="Sertifikasi"
      isError={!isLoading && !getIsValidCertificate(data)}
    >
      <div className="space-y-4">
        {isLoading && (
          <>
            {Array.from({ length: 7 })?.map((_, index) => (
              <DataBlockLoading
                index={index}
                key={`loading-shimmer-identity-${index}`}
              />
            ))}
            <div className="bg-surface-subdued px-4 py-3 rounded">
              <Shimmer width="100%" />
            </div>
          </>
        )}

        {!isLoading && (
          <>
            <DataBlock
              label="No. Sertifikat Pendidik"
              errorMessage={
                data.nomorSertifikatPendidik.validation ||
                data.tanggalSertifikatPendidik.validation
              }
            >
              {isValidNoSertifikatPendidik &&
                data.nomorSertifikatPendidik.value}
              {isValidNoSertifikatPendidik &&
                !!data.tanggalSertifikatPendidik.value && (
                  <>
                    <br />
                    Terbit {formatDate(data.tanggalSertifikatPendidik.value)}
                  </>
                )}
            </DataBlock>

            <DataBlock
              label="No. Sertifikat Guru Penggerak"
              isError={!isValidNoSertifikatGp && !isValidNoSertifikatDiklatCKS}
            >
              {isValidNoSertifikatGp
                ? data.nomorSertifikatGp.value
                : data.nomorSertifikatGp.validation || LABEL_NOT_AVAILABLE}
              {isValidNoSertifikatGp && !!data.tanggalSertifikatGp.value && (
                <>
                  <br />
                  Terbit {formatDate(data.tanggalSertifikatGp.value)}
                </>
              )}
            </DataBlock>

            <DataBlock
              label="No. Sertifikat Diklat CKS"
              isError={!isValidNoSertifikatGp && !isValidNoSertifikatDiklatCKS}
            >
              {isValidNoSertifikatDiklatCKS
                ? data.nomorSertifikatNrks.value
                : data.nomorSertifikatNrks.validation || LABEL_NOT_AVAILABLE}
              {isValidNoSertifikatDiklatCKS &&
                !!data.tahunSertifikatNrks.value && (
                  <>
                    <br />
                    Terbit {data.tahunSertifikatNrks.value}
                  </>
                )}
            </DataBlock>

            <DataInfo />
          </>
        )}
      </div>
    </Accordion>
  )
}
export default BlockCertification
